import styled, { css } from "styled-components";

export const Rotate = styled.div`
  @media screen and (orientation: landscape) {
    display: none;
  }

  @keyframes rotate {
    0% {
      transform: rotate(45deg);
    }
    70% {
      transform: rotate(-45deg);
    }
    100% {
      transform: rotate(45deg);
    }
  }

  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100vw;
  align-items: center;
  justify-content: center;

  .icon {
    width: min-content;
    animation: rotate 2s infinite;
  }

  svg {
    height: 70px;
    width: 70px;
    color: #555;
  }
  .labels {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 20px;
    span {
      color: #777;
      font-size: 14px;
    }
  }
`;

export const Container = styled.div`
  @media screen and (max-device-width: 640px) and (orientation: portrait) {
    display: none;
  }

  .application-container {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .application {
    display: flex;
    align-items: center;
    min-height: 100vh;
    width: 100vw;
  }

  ${props =>
    props.largeScreen
      ? css`
          .application {
            justify-content: center;
            div:first-child {
              margin-right: 150px;
              max-width: min-content;
            }

            div {
              div:first-child {
                margin-right: 0px;
              }
            }
          }
        `
      : css`
          .application {
            justify-content: space-around;
          }
        `}
  .modal-content {
    height: min-content;
    width: 500px;
    padding: 50px;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    h3 {
      margin: 0;
      padding: 0;
      color: #444;
    }
    h4 {
      margin: 0;
      color: #777;
      margin-bottom: 10px;
    }
    .buttons {
      display: flex;
      justify-content: space-around;

      button {
        display: flex;
        align-items: center;
        justify-content: center;
        border: none;
        outline: none;
        padding: 10px 15px;
        border-radius: 4px;
        width: 150px;
        font-family: inherit;
        font-size: 16px;
        color: #fff;
        font-weight: bold;
        cursor: pointer;

        transition: 0.3s;
        &:hover {
          opacity: 0.9;
        }

        span {
          margin-right: 10px;
        }
      }

      .restart {
        background-color: #67ae8b;
        svg {
          height: 18px;
          width: 18px;
          margin-right: 10px;
        }
      }

      .options {
        svg {
          height: 16px;
          width: 16px;
          margin-right: 10px;
        }
        background-color: #41a8bf;
      }
    }
  }
`;

export const AppLogo = styled.img`
  margin-top: 10px;
  height: 80px;
  position: absolute;
  cursor: pointer;

  ${props =>
    props.visible
      ? css``
      : css`
          display: none;
        `}
`;

export const ButtonVoltar = styled.a`
  display: flex;
  align-items: center;
  position: absolute;
  right: 20px;
  top: 10px;
  cursor: pointer;
  text-decoration: none;
  color: #333;
  padding: 5px;

  &:hover {
    text-decoration: underline;
  }

  svg {
    margin-right: 5px;
  }
`;

export const FloatingRestartButton = styled.button`
  background: #eee;
  position: absolute;
  right: 10px;
  bottom: 10px;
  padding: 10px;
  border: none;
  outline: none;
  border-radius: 8px;
  font-size: 24px;
  color: #555;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 44px;
  overflow: hidden;
  cursor: pointer;
  transition: width 0.15s ease-in;

  svg {
    display: block;
    width: 24px !important;
    height: 24px !important;
    min-width: 24px !important;
    min-height: 24px !important;
  }

  span {
    font-size: 16px;
    margin-left: 10px;
    font-weight: bold;
  }

  &:hover {
    width: 130px;
  }
`;
